define('adminSnippetsEditPopupView',[
  'app',
  'module',
  'backbone',
  'underscore',
  'jquery',
  'marionette',
  'bootbox',
  'template!adminSnippetsEditPopupView',
  'entities/admin/snippets'
], function (
  App,
  Module,
  Backbone,
  _,
  $,
  Marionette,
  Bootbox,
  Tpl
) {
  'use strict';

  // Languages exposed in the editor. Match the desktop tool's locale picker
  // (compuzz-tool/src/shared/types.ts → SUPPORTED_LOCALES). To add a language,
  // append its ISO 639-1 code here AND in that file. Kept alphabetical for
  // stable tab order.
  var SUPPORTED_LOCALES = ['da', 'de', 'en', 'es', 'fi', 'fr', 'it', 'nl', 'no', 'pl', 'pt', 'sv'];

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'admin-snippets-popup-edit-view',

    ui: {
      shortcut: '.input-shortcut',
      description: '.input-description',
      enabled: '.input-enabled',
      caseSensitive: '.input-case-sensitive',
      localeTab: '.locale-tab',
      bodyTextarea: '.input-body',
      saveButton: '.btn-save',
      closeButton: '.btn-close',
      errorBox: '.error-box'
    },

    events: {
      'click @ui.localeTab': 'onSwitchLocale',
      'input @ui.bodyTextarea': 'onBodyInput',
      'click @ui.saveButton': 'onSave',
      'click @ui.closeButton': 'onClose'
    },

    initialize: function () {
      this.snippetSecId = this.options.snippetSecId || null;
      this.isCreate = !this.snippetSecId;
      this.activeLocale = SUPPORTED_LOCALES[0];
      this.snippetData = {
        shortcut: '',
        description: '',
        enabled: true,
        caseSensitive: false,
        bodyByLocale: {}
      };
    },

    onShow: function () {
      if (this.isCreate) {
        this.render();
      } else {
        this.load();
      }
    },

    load: function () {
      App.request('snippets:get', this.snippetSecId).done(_.bind(function (data) {
        this.snippetData = {
          secId: data.secId,
          shortcut: data.shortcut || '',
          description: data.description || '',
          enabled: data.enabled !== false,
          caseSensitive: data.caseSensitive === true,
          bodyByLocale: data.bodyByLocale || {}
        };
        this.render();
      }, this)).fail(_.bind(function () {
        this.showError(_.i18n('common.error', null, 'Something went wrong. Please try again.'));
      }, this));
    },

    serializeData: function () {
      return {
        isCreate: this.isCreate,
        shortcut: this.snippetData.shortcut,
        description: this.snippetData.description,
        enabled: this.snippetData.enabled,
        caseSensitive: this.snippetData.caseSensitive,
        activeLocale: this.activeLocale,
        activeBody: this.snippetData.bodyByLocale[this.activeLocale] || '',
        locales: SUPPORTED_LOCALES,
        labels: {
          shortcut: _.i18n('admin.snippets.shortcut', null, 'Shortcut'),
          description: _.i18n('admin.snippets.description', null, 'Description'),
          enabled: _.i18n('admin.snippets.enabled', null, 'Enabled'),
          caseSensitive: _.i18n('admin.snippets.caseSensitive', null, 'Case-sensitive'),
          body: _.i18n('admin.snippets.body', null, 'Body'),
          save: _.i18n('common.save', null, 'Save'),
          close: _.i18n('common.close', null, 'Close')
        }
      };
    },

    onSwitchLocale: function (e) {
      // Persist every form field — not just the body — before re-rendering,
      // otherwise re-render reads stale values from snippetData and wipes
      // anything the user just typed into shortcut/description/toggles.
      this.captureForm();
      this.activeLocale = $(e.currentTarget).data('locale');
      this.render();
    },

    onBodyInput: function () {
      this.captureBody();
    },

    captureBody: function () {
      if (this.ui.bodyTextarea && this.ui.bodyTextarea.length) {
        this.snippetData.bodyByLocale[this.activeLocale] = this.ui.bodyTextarea.val();
      }
    },

    captureForm: function () {
      if (this.ui.shortcut && this.ui.shortcut.length) {
        this.snippetData.shortcut = this.ui.shortcut.val() || '';
      }
      if (this.ui.description && this.ui.description.length) {
        this.snippetData.description = this.ui.description.val() || '';
      }
      if (this.ui.enabled && this.ui.enabled.length) {
        this.snippetData.enabled = this.ui.enabled.is(':checked');
      }
      if (this.ui.caseSensitive && this.ui.caseSensitive.length) {
        this.snippetData.caseSensitive = this.ui.caseSensitive.is(':checked');
      }
      this.captureBody();
    },

    collectPayload: function () {
      this.captureForm();
      var payload = {
        shortcut: $.trim(this.snippetData.shortcut || ''),
        description: this.snippetData.description || '',
        enabled: this.snippetData.enabled,
        caseSensitive: this.snippetData.caseSensitive,
        bodyByLocale: {}
      };
      // Drop empty entries so the backend doesn't store blank locales.
      _.each(this.snippetData.bodyByLocale, function (text, locale) {
        if (text && $.trim(text).length > 0) {
          payload.bodyByLocale[locale] = text;
        }
      });
      if (this.snippetData.secId) {
        payload.secId = this.snippetData.secId;
      }
      return payload;
    },

    onSave: function () {
      var payload = this.collectPayload();
      if (!payload.shortcut) {
        this.showError(_.i18n('admin.snippets.shortcutRequired', null, 'Please enter a shortcut.'));
        return;
      }
      if (_.keys(payload.bodyByLocale).length === 0) {
        this.showError(_.i18n('admin.snippets.bodyRequired', null, 'Please enter a body in at least one language.'));
        return;
      }

      var op = this.isCreate ? 'snippets:create' : 'snippets:update';
      var self = this;
      App.request(op, payload).done(function () {
        if (self.options.onConfirm) self.options.onConfirm();
        self.onClose();
      }).fail(function (xhr) {
        if (xhr && xhr.status === 409) {
          self.showError(_.i18n('admin.snippets.shortcutTaken', null, 'That shortcut is already used by another snippet.'));
        } else {
          self.showError(_.i18n('common.error', null, 'Something went wrong. Please try again.'));
        }
      });
    },

    showError: function (msg) {
      if (this.ui.errorBox && this.ui.errorBox.length) {
        this.ui.errorBox.text(msg).show();
      } else {
        Bootbox.alert(msg);
      }
    },

    onClose: function () {
      if (this.windowView) this.windowView.close();
    }
  });
});

